import { useMutation, useQuery } from '@tanstack/react-query';
import { aiApi, TimelineSummary, ProviderMetricSummary } from '@/api/ai-api';

export interface TimelineInput {
  patientId: string;
  medicalHistory?: {
    consultations?: Array<{ date: string; specialty?: string; summary?: string; doctorName?: string }>;
    prescriptions?: Array<{ date: string; medications: string[]; doctorName?: string }>;
    diagnoses?: Array<{ date: string; description: string; cidCode?: string }>;
    exams?: Array<{ date: string; exam: string; result?: string }>;
    certificates?: Array<{ date: string; reason: string; daysOff?: number }>;
    evolutions?: Array<{ date: string; doctorName?: string; summary: string }>;
    allergies?: string[];
    chronicDiseases?: string[];
  };
}

export function useAITimeline() {
  return useMutation<TimelineSummary, Error, TimelineInput>({
    mutationFn: async (payload: TimelineInput) => aiApi.generateTimeline(payload),
  });
}

export function useAIMetrics(provider?: string, sinceHours?: number) {
  return useQuery<ProviderMetricSummary, Error>({
    queryKey: ['ai-metrics', provider, sinceHours],
    queryFn: () => aiApi.getMetricsSummary(provider, sinceHours),
    enabled: !!provider || !!sinceHours,
    refetchInterval: 60000,
  });
}